import Vue from 'vue'
import StoragePlugin from 'vue-web-storage'

try {
    Vue.use(StoragePlugin, {
        prefix: 'app.sph.lk.'
    })
} catch(ignored) {
    Vue.prototype.$localStorage = {
        get: function (key, def){return def},
        set: function (){}
    }
}